import type { TOC } from "@ember/component/template-only";
import { t } from "ember-intl";
import GInput from "glesys-controlpanel/components/g-input";
import Box from "glesys-controlpanel/components/box";
// @ts-expect-error: no type declarations for yet .gjs component
import Label from "glesys-controlpanel/components/label";

interface CampaignCodeBoxSignature {
  Element: HTMLDivElement;
  Args: {
    platform: string;
    value?: string | null;
  };
}

const CampaignCodeBox: TOC<CampaignCodeBoxSignature> = <template>
  <Box data-test-server-create-show-campaign-code={{@platform}} @collapsable={{true}} ...attributes>
    <:header>
      {{t "servers.create.campaign-code"}}
    </:header>
    <:default>
      <div>
        <Label for="campaignCode">
          {{t "label.code"}}
        </Label>
        <GInput
          aria-label={{t "servers.create.campaign-code"}}
          data-test-server-create-campaign-code-input={{@platform}}
          name="campaignCode"
          value={{@value}}
        />
      </div>
    </:default>
  </Box>
</template>;

export default CampaignCodeBox;
